import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import ButtonComponent from '../../buttons/ButtonComponent/ButtonComponent';
import { buttonVariants } from '../../buttons/types';
import { generalEnums } from '../../../../utils/enums';
import colors from '../../../../scss/colors';

export default function TimeandExpenseCard({
  type,
  styles,
  status,
  placementStatus,
  list,
  pending,
  handleButtonClick
}) {
  const uniqueId = useId();
  const { t } = useTranslation();
  const accessTo = useSelector((state) => state.accessToParts);

  const renderButton = (count, statusType, variant) => {
    if (!count) return null;

    return (
      <Link
        to={`/dashboard/${type === generalEnums.TIMESHEET ? 'timesheets' : 'expenses'}?page=1&status=${statusType}`}
        onClick={(e) => handleButtonClick(e, statusType, count)}
        key={uniqueId}
      >
        <ButtonComponent variant={variant} text={t(`dashboard.cards.new${statusType}`)}>
          <span className={styles.boldedFont}>{count}</span>
        </ButtonComponent>
      </Link>
    );
  };

  const renderContent = () => {
    if (list?.ApprovedCount === 0 && list?.RejectedCount === 0) {
      return <h5 key={uniqueId}>{t('dashboard.cards.noupdatestoday')}</h5>;
    }
    return (
      <>
        {renderButton(list?.ApprovedCount, 'Approved', buttonVariants.ROUNDED_NOTIFY_POSITIVE)}
        {renderButton(list?.RejectedCount, 'Rejected', buttonVariants.ROUNDED_NOTIFY_NEGATIVE)}
      </>
    );
  };

  const renderPending = () => (
    <Link
      to={`/dashboard/${type === generalEnums.TIMESHEET ? 'timesheets' : 'expenses'}?page=1&status=Pending`}
      onClick={(e) => e.stopPropagation()}
      key={uniqueId}
    >
      <ButtonComponent
        variant={buttonVariants.ROUNDED_NOTIFY_PENDING}
        text={type === generalEnums.TIMESHEET ? t('dashboard.cards.newtimesheets') : t('dashboard.cards.newexpenses')}
      >
        <span className={styles.boldedFont}>{list}</span>
      </ButtonComponent>
    </Link>
  );

  if (status && placementStatus && !pending && accessTo.tAndEContractor) {
    return renderContent();
  }

  if (!pending && accessTo.tAndEApprover) {
    return list === 0 ? (
      <span key={uniqueId} className={styles.noUpdates}>
        {t('dashboard.cards.noupdatestoday')}
      </span>
    ) : (
      renderPending()
    );
  }

  if (pending) {
    return <CircularProgress key={uniqueId} sx={{ color: colors.PRIMARY_BLUE }} size={60} />;
  }

  if (!status) {
    return (
      <h5 key={uniqueId} className={styles.validationMessage}>
        {type === generalEnums.TIMESHEET
          ? t('dashboard.cards.timesheetvalidate')
          : t('dashboard.cards.expensevalidate')}
      </h5>
    );
  }

  if (!placementStatus) {
    return (
      <h5 key={uniqueId} className={styles.validationMessage}>
        {type === generalEnums.TIMESHEET
          ? t('dashboard.cards.timesheetPlacementValidate')
          : t('dashboard.cards.expensePlacementValidate')}
      </h5>
    );
  }

  return null; // Handle case where no conditions are met
}
